import { Tab } from '../../types'

export const commissionTabs: Tab[] = [
  { id: 'notpaid', label: 'Not Paid' },
  { id: 'paid', label: 'Paid' },
]

export const commissionTableHeaders: Tab[] = [
  { id: 'invoice', label: 'Invoice#' },
  { id: 'company', label: 'Company' },
  { id: 'rate', label: 'Rate' },
  { id: 'amount', label: 'Amount' },
  { id: 'commission', label: 'Commission' },
]

